import {toCamelCase} from 'case-converter'
import {
  fetchErrorsHandler,
  fetchStart, fetchSuccessful,
  fetchSynchronizer,
  filterByValues, getFetchDate,
  switchMbToGb
} from '~/helpers/prices/_utils/prices'
import {Resource} from '~/helpers/prices/cdn/enum'

export const state = () => ({
  pricesCdn: [],
  cdnFetchDate: '',
  fetchingNow: false,
  fetchingResult: ''
})

export const mutations = {
  setCdnPrices(state, value) {
    state.pricesCdn = value
  },
  setCdnFetchDate(state, value) {
    state.cdnFetchDate = value
  },
  setFetchingState(state, value) {
    state.fetchingNow = value
  },
  setFetchingResult(state, value) {
    state.fetchingResult = value
  }
}

export const actions = {
  async fetchCdnPrices({commit, state}, options) {
    if (state.fetchingNow) {
      return fetchSynchronizer(commit, state)
    } else {
      fetchStart(commit)

      return this.$http.$get('https://api.selectel.ru/prices/cdn?currency=rub', options)
        .then(res => toCamelCase(res))
        .then(prices => switchMbToGb(prices))
        .then(prices => {
          commit('setCdnPrices', prices)

          commit('setCdnFetchDate', getFetchDate())

          fetchSuccessful(commit)

          return prices
        })
        .catch(err => fetchErrorsHandler(commit, err))
    }
  }
}

export const getters = {
  getCdnFetchDate(state) {
    return state.cdnFetchDate
  },
  getCdnPrices(state) {
    return state.pricesCdn
  },
  getCdnFilteredPrices(state) {
    return filterByValues(
      state.pricesCdn,
      [
        {
          key: 'resource',
          values: [Resource.GCORE_TRAFFIC_MB, Resource.AKAMAI_TRAFFIC_MB]
        }
      ]
    )
  },
  getCdnStreamingPrices(state) {
    return filterByValues(
      state.pricesCdn,
      [
        {
          key: 'resource',
          values: [Resource.STREAMING]
        }
      ]
    )
  }
}